import { Box, Typography } from "@mui/material";
import SingleAutocomplete from "../shared/singleAutocomplete";
import { useOrderHistoryFilters } from "@/app/hooks/useOrderHistoryFilter";
import { OrderHistoryFilterFieldEnum } from "@/enums/orderHistoryFilterFiledEnum";
import { ORDER_HISTORY_SORT_OPTIONS } from "@/app/options/OrderHistoryFiltersOptions";
import { useState, useEffect } from "react";
import { Option } from "@/app/interfaces/Option";

const OrderHistorySortBy = () => {
  const { filters, updateFilter } = useOrderHistoryFilters();

  const [selectedOption, setSelectedOption] = useState<any>(
    ORDER_HISTORY_SORT_OPTIONS[3]
  );

  useEffect(() => {
    const initialOption =
      ORDER_HISTORY_SORT_OPTIONS.find(
        (option) => option.value === filters.sortBy
      ) ?? ORDER_HISTORY_SORT_OPTIONS[3];
    setSelectedOption(initialOption);
    updateFilter(
      OrderHistoryFilterFieldEnum.SORT_BY,
      initialOption.value as string
    );
  }, [updateFilter, filters.sortBy]);

  const handleChange = (_: React.SyntheticEvent, newValue: Option | null) => {
    if (newValue) {
      setSelectedOption(newValue);
      updateFilter(
        OrderHistoryFilterFieldEnum.SORT_BY,
        newValue.value as string
      );
    }
  };

  return (
    <Box
      sx={{
        m: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Order History
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          minWidth: 300,
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", whiteSpace: "nowrap" }}
        >
          Sort by:
        </Typography>
        <SingleAutocomplete
          name="orderHistorySortBy"
          label=""
          options={ORDER_HISTORY_SORT_OPTIONS}
          value={selectedOption}
          onChange={handleChange}
          size="small"
        />
      </Box>
    </Box>
  );
};

export default OrderHistorySortBy;
